const mediaItems = [
  {
    id: 1,
    title: '某顶流男星深夜出入私密会所全程直击',
    duration: '04:32',
    views: '128.5万',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20private%20club%20entrance%20at%20night%20with%20paparazzi%20vibe%2C%20dramatic%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20news%20breaking%20story%20visual%2C%20dark%20atmosphere%20with%20glowing%20street%20lights%2C%20editorial%20photography%20style&width=800&height=500&seq=media-01-night&orientation=landscape',
  },
  {
    id: 2,
    title: '网红圈大型翻车：多名博主人设崩塌合集',
    duration: '08:15',
    views: '203.7万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20breakdown%20visual%20with%20shattered%20phone%20screen%20and%20dramatic%20warm%20orange%20lighting%2C%20entertainment%20scandal%20concept%2C%20bold%20editorial%20style%2C%20high%20contrast%20composition&width=800&height=500&seq=media-02-influencer&orientation=landscape',
  },
  {
    id: 3,
    title: '圈内人独家爆料：某综艺选角内幕全揭秘',
    duration: '12:48',
    views: '167.3万',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20variety%20show%20casting%2C%20dramatic%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20industry%20secret%20visual%2C%20mysterious%20atmosphere%2C%20editorial%20photography%20style&width=800&height=500&seq=media-03-insider&orientation=landscape',
  },
  {
    id: 4,
    title: '塌房预警：某艺人近期异常行为时间线梳理',
    duration: '06:50',
    views: '98.2万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20timeline%20visual%20of%20celebrity%20scandal%20unfolding%2C%20warm%20orange%20and%20coral%20lighting%2C%20entertainment%20news%20breaking%20story%2C%20suspenseful%20atmosphere%2C%20editorial%20photography%20style%2C%20dark%20mood&width=800&height=500&seq=media-04-timeline&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">现场直击</h2>
          <p className="text-sm text-foreground-500">第一手视频爆料，还原事件真相</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <article key={item.id} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200/50 transition-all">
              <div className="relative w-full aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-50 text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}